// extracted by mini-css-extract-plugin
export default {"tWrapper":"button__tWrapper__SrYL9","tooltip":"button__tooltip__z9d7I","icon":"button__icon__kL5Qz"};